document.addEventListener("turbo:load", function() {
  if (!App.currentPageIs("sessions", "new")) { return; }

  // Listens to a click on the "Sign in with Google" button
  //
  return App.oauthConnect(".js-oauth-btn", "/auth/google");
});
